import { Button, Input, RadioGroupButtons, TextInput } from '@cimplico/components';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { UserRoleEnum } from '../../types/user';

type NewUserRowProps = {
    id: string;
    email: string;
    role: UserRoleEnum;
    errorMessage?: string;
    canRemove: boolean;
    isSubmitting: boolean;
    onDelete: (id: string) => void;
    onEmailChange?: (id: string, email: string) => void;
    onRoleChange: (id: string, role: UserRoleEnum) => void;
};

function NewUserRow({
    id,
    email,
    role,
    errorMessage,
    canRemove,
    isSubmitting,
    onDelete,
    onEmailChange,
    onRoleChange,
}: NewUserRowProps): JSX.Element {
    return (
        <div className="mt-2 flex flex-row justify-between">
            <div className="w-[275px]">
                <Input
                    placeholder="e.g. you@email.com"
                    label="Email"
                    onChange={(e): void => onEmailChange && onEmailChange(id, e.target.value)}
                    value={email}
                    errorMessage={errorMessage}
                    disabled={isSubmitting || !onEmailChange}
                    type="text"
                />
            </div>
            <div>
                <RadioGroupButtons
                    groupName={id}
                    onChange={(e): void => onRoleChange(id, e.target.value as UserRoleEnum)}
                    options={[
                        {
                            label: 'User',
                            value: UserRoleEnum.USER,
                            disabled: isSubmitting,
                        },
                        {
                            label: 'Manager',
                            value: UserRoleEnum.MANAGER,
                            disabled: isSubmitting,
                        },
                        {
                            label: 'External User',
                            value: UserRoleEnum.EXTERNAL_USER,
                            disabled: isSubmitting,
                        },
                    ]}
                    title="Role"
                    value={role}
                />
            </div>
            <div className="mt-6" style={{ width: 'fit-content' }}>
                <Button
                    leftIcon={<XMarkIcon />}
                    onClick={(): void => onDelete(id)}
                    size="sm"
                    type="hollow"
                    disabled={!canRemove || isSubmitting}
                />
            </div>
        </div>
    );
}

export default NewUserRow;
